// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","contentWrap":"_1TB2PkyaodsNQcNUmhZpxC"};